import React, { useContext } from "react";
import { Redirect } from "react-router";
import { Auth } from "aws-amplify";
import { onStateChangeContext } from "../../Components/Auth/SelfHostedAuth";
import { useEffect } from "react";

export default function SignOut() {
  const onStateChange = useContext(onStateChangeContext);

  useEffect(() => {
    async function signOut() {
      const currentUser = Auth.userPool.getCurrentUser();
      await currentUser.signOut();
      onStateChange("signedOut", null);
    }

    signOut();
  }, []);

  return <Redirect to="/" />;
}
